import { TrackerPersonalLoading } from '@/views/tracker/personal/tracker-personal.loading';

export default TrackerPersonalLoading;
